


































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {IContentSection} from '@/components/types';

import {Back, gsap} from '@/utils/gsap';

import Typo from '@/components/ui/Typo.vue';

@Component({})
export default class ContentSection extends Vue {
	@Prop({required: true}) readonly content: IContentSection;
	@Prop({default: 'white'}) readonly variant: 'white' | 'black';
	@Prop({default: false}) readonly animation?: boolean;

	afterLoadTL: any = undefined;

	$refs: {
		headline: Typo
		perex: Typo
		buttons: HTMLElement
	};

	get classList(): (string | null)[] {
		return [
			'content-section',
			this.variant ? `content-section--${this.variant}` : null,
		]
	}

	get preloaderState(): boolean {
		return this.$store.state.global.preloaded;
	}

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}
		if (!this.animation) {
			return;
		}

		if (this.preloaderState) {
			return;
		}

		this.afterLoadTL = gsap.timeline({paused: true});

		const headline = this.$refs.headline.$el;
		const perex = this.$refs.perex.$el;
		const buttons = this.$refs.buttons;
		// todo: you know what to do, dont you?
		const header = document.querySelector('.header')!;

		this.afterLoadTL
			.set([headline, perex], {autoAlpha: 0, scale: 0})
			.set([buttons, header], {autoAlpha: 0, transformOrigin: '50% 0'})

			.fromTo([headline, perex], {
				scale: 0.8,
				rotationX: -10,
			}, {
				stagger: 0.15,
				duration: 0.8,
				scale: 1,
				rotationX: 0,
				autoAlpha: 1,
				ease: Back.easeOut.config(4)
			})
			.fromTo([header, buttons], {
				scale: 1.2,
				rotationX: -20,
			}, {
				duration: 0.5,
				stagger: 0.2,
				scale: 1,
				rotationX: 0,
				autoAlpha: 1,
				ease: Back.easeOut.config(4)
			})
			.add(() => this.$store.dispatch('preloaded', true));

		this.$root.$on('isLoaded', (isLoaded: boolean) => {
			if (!isLoaded || !this.animation) {
				return;
			}

			this.afterLoadTL.play();
		});
	}
}
